import styles from "./header.css";
import * as React from "react";

export default class HeaderDivider extends React.Component {
  render() {
    return <img className={styles.dividerButton} src="res/divider.svg" />;
  }
}
